import { instance2 } from './base';

const RewardController = {
    /**
     * Get rewards catalog
     */
    getRewards: (params = {}, signal) => {
        return instance2.get('/v1/rewards', { params, signal });
    },

    /**
     * Get filter options (categories, brands, point ranges)
     */
    getRewardOptions: (signal) => {
        return instance2.get('/v1/rewards/options', { signal });
    },

    /**
     * Get specific reward detail
     */
    getRewardDetail: (id, signal) => {
        return instance2.get(`/v1/rewards/${id}`, { signal });
    },

    /**
     * Get redemption history for the current customer
     */
    getRedemptionHistory: (params = {}, signal) => {
        return instance2.get('/v1/rewards/redemptions', { params, signal });
    },

    /**
     * Reserve/Redeem a reward
     */
    redeemReward: (rewardId, data = {}) => {
        return instance2.post('/v1/rewards/redeem', {
            reward_id: rewardId,
            ...data,
        });
    },

    /**
     * Get current customer's reward points balance
     */
    getPointBalance: (signal) => {
        return instance2.get('/v1/shop/customer/reward-points', { signal });
    },
};

export default RewardController;
